var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 7.79167C6.41667 7.03083 7.04 6.41667 7.79167 6.41667C8.54333 6.41667 9.16667 7.03083 9.16667 7.79167C9.16667 8.5525 8.5525 9.16667 7.79167 9.16667C7.03083 9.16667 6.41667 8.5525 6.41667 7.79167Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.375C5.68333 1.375 1.375 5.68333 1.375 11C1.375 16.3167 5.68333 20.625 11 20.625C16.3167 20.625 20.625 16.3167 20.625 11C20.625 5.68333 16.3167 1.375 11 1.375ZM7.79167 5.5C9.05667 5.5 10.0833 6.52667 10.0833 7.79167C10.0833 9.05667 9.05667 10.0833 7.79167 10.0833C6.52667 10.0833 5.5 9.05667 5.5 7.79167C5.5 6.52667 6.52667 5.5 7.79167 5.5ZM14.2083 16.5C12.9433 16.5 11.9167 15.4733 11.9167 14.2083C11.9167 12.9433 12.9433 11.9167 14.2083 11.9167C15.4733 11.9167 16.5 12.9433 16.5 14.2083C16.5 15.4733 15.4733 16.5 14.2083 16.5ZM6.15083 16.5L5.5 15.8492L15.8583 5.5L16.5 6.15083L6.15083 16.5ZM14.2083 12.8333C13.4567 12.8333 12.8333 13.4475 12.8333 14.2083C12.8333 14.9692 13.4567 15.5833 14.2083 15.5833C14.96 15.5833 15.5833 14.9692 15.5833 14.2083C15.5833 13.4475 14.9692 12.8333 14.2083 12.8333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPercent);
export default __webpack_public_path__ + "static/media/ic-percent.7765be65abf3d7a61df227b6205febd7.svg";
export { ForwardRef as ReactComponent };